export default function GreenBackgroundShape({
	children,
	shapeType: type = "smooth",
}: {
	children: React.ReactNode;
	shapeType?: "sharp" | "smooth";
}) {
	return (
		<div className="h-full w-full bg-transparent relative">
			<div className="bg-primary-600 pt-4">{children}</div>

			{type === "sharp" && (
				<svg
					width="360"
					height="84"
					viewBox="0 0 360 84"
					className="w-full h-auto -translate-y-[1px] fill-primary-600"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					preserveAspectRatio="none"
					role="img"
					aria-label="Background"
				>
					<g clipPath="url(#clip0_17_19)">
						<path d="M0 -191H360V-12.106C360 20.7023 360 37.1064 350.334 48.3518C340.667 59.5971 324.449 62.0604 292.013 66.987L234.359 75.7438C207.231 79.864 193.667 81.9242 180 81.9242C166.333 81.9242 152.769 79.864 125.641 75.7438L67.987 66.987C35.5508 62.0604 19.3327 59.5971 9.66636 48.3518C0 37.1064 0 20.7023 0 -12.1059V-191Z" />
					</g>
					<defs>
						<clipPath id="clip0_17_19">
							<rect width="360" height="84" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)}

			{type === "smooth" && (
				<svg
					width="360"
					height="84"
					viewBox="0 0 360 84"
					preserveAspectRatio="none"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					className="w-full w-full -translate-y-[1px] fill-primary-600"
					role="img"
					aria-label="Background"
				>
					<g clipPath="url(#clip0_17_19)">
						<path d="M0 -191H360V-12.106C360 20.7023 360 37.1064 350.334 48.3518C340.667 59.5971 324.449 62.0604 292.013 66.987L234.359 75.7438C207.231 79.864 193.667 81.9242 180 81.9242C166.333 81.9242 152.769 79.864 125.641 75.7438L67.987 66.987C35.5508 62.0604 19.3327 59.5971 9.66636 48.3518C0 37.1064 0 20.7023 0 -12.1059V-191Z" />
					</g>
					<defs>
						<clipPath id="clip0_17_19">
							<rect width="360" height="84" fill="white" />
						</clipPath>
					</defs>
				</svg>
			)}
		</div>
	);
}
